<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells_hd">基础信息</div>
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <employee-field
          slot="aa_em_name"
          :label="customLabel.aa_em_name || '申请人'"
          v-model="form.main.aa_em_name"
          @select="onSelectHandover"
        />
        <position-field
          slot="aa_role_name"
          :label="customLabel.aa_role_name || '岗位名称'"
          v-model="form.main.aa_role_name"
          @select="onSelectRole"
          :emId="form.main.aa_em_id"
        />
        <div class="weui-cell" slot="aa_department">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.aa_department || "部门名称"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <span>{{ form.main.aa_department }}</span>
          </div>
        </div>
        <module-field
          slot="aa_module_name"
          :label="customLabel.aa_module_name || '模块名称'"
          v-model="form.main.aa_module_name"
          @select="onSelectModule"
        />
        <form-field
          slot="aa_group_name"
          :label="customLabel.aa_group_name || '单据名称'"
          v-model="form.main.aa_group_name"
          :moduleId="form.main.aa_module_id"
          @select="onSelectGroup"
        />
        <check-group-field ref="childRef"
          :label="customLabel.aa_resource_name || '操作'"
          slot="aa_resource_name"
          :items="list"
          v-model="form.main.aa_resource_name"
        />
        <div class="weui-cell" slot="aa_content">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.aa_content || "申请内容"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              placeholder="请输入内容"
              rows="3"
              v-model="form.main.aa_content"
              maxlength="300"
            ></textarea>
            <div class="weui-textarea-counter">
              <span>{{
                form.main.aa_content ? form.main.aa_content.length : 0
              }}</span
              >/300
            </div>
          </div>
        </div>
        <div class="weui-cell" slot="aa_reason">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.aa_reason || "申请原因"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              placeholder="请输入原因"
              rows="3"
              v-model="form.main.aa_reason"
              maxlength="300"
            ></textarea>
            <div class="weui-textarea-counter">
              <span>{{
                form.main.aa_reason ? form.main.aa_reason.length : 0
              }}</span
              >/300
            </div>
          </div>
        </div>
      </custom-layout>
      <div class="weui-cells">
        <file-field v-model="form.main.aa_attach" ref="pu_attach" />
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import PositionField from "@/components/field/PositionField.vue";
import ModuleField from "@/components/field/ModuleField.vue";
import FormField from "@/components/field/FormField.vue";
import CheckGroupField from "@/components/field/CheckGroupField.vue";
import FileField from "@/components/field/FileField.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    EmployeeField,
    PositionField,
    ModuleField,
    FormField,
    CheckGroupField,
    FileField,
  },
  data() {
    return {
      baseUrl: "/api/oa/authApply",
      codeField: "aa_code",
      statusField: "aa_statuscode",
      caller: "AuthApply",
      xtype: "oa-authApply-formpanel",
      form: {
        main: {
          aa_group_id: null,
          aa_resource_name: null,
          aa_resource_name_array: [],
        },
      },
      list: [],
    };
  },
  watch: {
    "form.main.aa_group_id"(newVal) {
      this.onChangeGroup(newVal);
    },
  },

  methods: {
    onSelectHandover(e) {
      var main = this.form.main;
      main.aa_em_id = e.id;
      main.aa_em_code = e.em_code;
      main.aa_department = e.dp_name;
      main.aa_department_code = e.dp_code;
      main.aa_department_id = e.dp_id;
    },
    onSelectRole(e) {
      var main = this.form.main;
      main.aa_role_id = e.id;
    },
    onSelectModule(e) {
      var main = this.form.main;
      main.aa_module_id = e.id;
      main.aa_group_id = null;
      main.aa_group_name = null;
      main.aa_resource_name = "";
      main.aa_resource_id = "";
      main.aa_resource_name_array = [];
      this.list = [];
    },
    onChangeGroup(value) {
      let me = this;
      if (value) {
        me.$loading({
          url: "/api/account/resource/getResourcesByGroupId",
          params: {
            groupId: value,
          },
        }).then(function (res) {
          if (res.success) {
            if (res.data && res.data.length > 0) {
              me.list = [];
              res.data.map((item) => {
                me.list.push({
                  display: item.name,
                  value: item.name,
                });
              });
            }
          } else {
            me.$weui.topTips(res.message, 2000);
          }
        });
      }
    },
    onSelectGroup(e) {
      var main = this.form.main;
      main.aa_group_id = e.id;
      main.aa_resource_name = "";
      main.aa_resource_id = "";
      main.aa_resource_name_array = [];
      this.list = [];
      this.$refs.childRef.clear()
     
    },

    save() {
      var me = this,
        main = me.form.main;
      if (!main.aa_em_name) {
        me.$weui.topTips("请选择申请人", 2000);
      } else if (!main.aa_role_name) {
        me.$weui.topTips("请选择岗位名称", 2000);
      } else if (!main.aa_module_name) {
        me.$weui.topTips("请选择模块名称", 2000);
      } else if (!main.aa_group_name) {
        me.$weui.topTips("请选择单据名称", 2000);
      } else if (!main.aa_resource_name || main.aa_resource_name == "") {
        me.$weui.topTips("请选择操作", 2000);
      } else {
        me.p_save();
      }
    },
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  align-items: center;
}
.time {
  flex: 1;
}
.unit {
  width: 50px;
}
</style>